<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addTeamMember.title')" backdrop shadow
            :visible="allowAddTeamMember" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.firstNameLabel')" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.first_name" type="text" :placeholder="$t('teamMemberShared.firstNamePlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.first_name" class="field-error">
                                {{ errors.first_name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.lastNameLabel')" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.last_name" type="text" :placeholder="$t('teamMemberShared.lastNamePlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.last_name" class="field-error">
                                {{ errors.last_name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.usernameLabel')" class="text-left mb-0">
                            <b-form-input type="text" autocomplete="new-username" :placeholder="$t('teamMemberShared.usernamePlaceholder')"
                                v-model="newTeamMember.username" class="unit"></b-form-input>
                            <p v-if="errors && errors.username" class="field-error text-left">
                                {{ errors.username[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.passwordLabel')"
                            class="text-left mb-0 label font-weight-normal password show-password-section">
                            <b-form-input :type="showPassword ? 'text' : 'password'" autocomplete="new-password"
                                :placeholder="$t('teamMemberShared.passwordPlaceholder')" v-model="newTeamMember.password" class="unit"></b-form-input>
                            <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'"
                                @click="showPassword = !showPassword"></b-icon>
                            <p v-if="errors && errors.password" class="field-error text-left">
                                {{ errors.password[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.emailLabel')" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.email" type="text" :placeholder="$t('teamMemberShared.emailPlaceholder')" class="unit"
                                required></b-form-input>
                            <p v-if="errors &&
                                errors.email
                                " class="field-error">
                                {{ errors.email[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.phoneLabel')" class="text-left position-relative mb-0">
                            <b-input-group size="lg" class="w-100" prepend="+1">
                                <b-form-input v-mask="phoneMask" class="f-14" v-model="newTeamMember.phone"></b-form-input>
                            </b-input-group>
                            <p v-if="errors && errors.phone" class="field-error">
                                {{ errors.phone[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.licenseLabel')" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.license_number" type="text" :placeholder="$t('teamMemberShared.licensePlaceholder')"
                                class="unit" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('teamMemberShared.stateLabel') }}</label>
                        <v-select class="f-12 h-40px" :options="states" :reduce="(option) => option.id"
                            v-model="newTeamMember.license_state.id" />
                    </b-col>
                    <b-col lg="6" md="12" sm="12" class="text-left mt-3">
                        <v-app>
                            <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                    <label class="text-left w-fit-content" v-on="on" v-bind="attrs">{{ $t('addTeamMember.sendInviteLabel') }}</label>
                                </template> {{ $t('addTeamMember.emailRequired') }}
                            </v-tooltip>
                        </v-app>
                        <b-form-checkbox name="check-button" class="ml-1px" v-model="newTeamMember.inviteNewMember"
                            :disabled="!checkEmail(newTeamMember.email)" switch></b-form-checkbox>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.tagsHeading') }}</h3>
                    <b-col md="12" class="mt-3">
                        <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                            v-model="driverTags" />
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.divisionHeading') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <v-select class="f-12" :clearable="false" :options="allDivisions" v-model="newTeamMember.division"
                            :reduce="(option) => option.id" />
                    </b-col>
                    <p v-if="errors && errors.division" class="field-error px-3">
                        {{ errors.division[0] }}
                    </p>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.detailsHeading') }}</h3>
                    <!-- <b-col sm="12" class="text-left select_arrow mt-3">
                        <label>Type:</label>
                        <b-form-select class="f-12" :options="[
                            { value: null, text: '' },
                            { value: 'Company', text: 'Company' },
                            {
                                value: 'Owner Operator',
                                text: 'Owner Operator',
                            },
                        ]" v-model="newTeamMember.driver_type"></b-form-select>
                        <p v-if="errors && errors.driver_type" class="field-error mb-lg-3">
                            {{ errors.driver_type[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="text-left select_arrow mt-3">
                        <label>CDL:</label>
                        <b-form-select class="f-12" :options="[
                            {
                                value: null,
                                text: '',
                            },
                            {
                                value: true,
                                text: 'Yes',
                            },
                            {
                                value: false,
                                text: 'No',
                            },
                        ]" v-model="newTeamMember.CDL"></b-form-select>
                    </b-col> -->
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('teamMemberShared.driverIdLabel')" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.employee_id" type="text" :placeholder="$t('teamMemberShared.driverIdPlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.employee_id" class="field-error">
                                {{ errors.employee_id[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col sm="12" class="mt-3">
                        <b-form-group label="Driver Pin:" class="text-left mb-0">
                            <b-form-input v-model="newTeamMember.pin_code" type="text" placeholder="Enter Pin" class="unit"
                                required></b-form-input>
                            <p v-if="errors && errors.pin_code" class="field-error">
                                {{ errors.pin_code[0] }}
                            </p>
                        </b-form-group>
                    </b-col> -->
                    <b-col sm="12" class="text-left mt-3">
                        <label for="dob-datepicker" class="state">{{ $t('teamMemberShared.dobLabel') }}</label>
                        <date-picker v-model="newTeamMember.dob" :formatter="momentFormat" :range-separator="' - '"
                            @clear="newTeamMember.dob = ''" :placeholder="$t('teamMemberShared.selectDate')" class="date-picker-custom"
                            :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.dob" class="field-error">
                            {{ errors.dob[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label for="active-date" class="state">{{ $t('teamMemberShared.activeDateLabel') }}</label>
                        <date-picker v-model="newTeamMember.activate_date" :formatter="momentFormat"
                            :range-separator="' - '" @clear="newTeamMember.activate_date = ''" :placeholder="$t('teamMemberShared.selectDate')"
                            class="date-picker-custom" :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.activate_date" class="field-error">
                            {{ errors.activate_date[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label for="inactive-date" class="state">{{ $t('teamMemberShared.inactiveDateLabel') }}</label>
                        <date-picker v-model="newTeamMember.inactive_date" :formatter="momentFormat"
                            :range-separator="' - '" @clear="newTeamMember.inactive_date = ''" :placeholder="$t('teamMemberShared.selectDate')"
                            class="date-picker-custom" :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.inactive_date" class="field-error">
                            {{ errors.inactive_date[0] }}
                        </p>
                    </b-col>
                </b-row>
                <hr class="m-4" v-if="driverCustomFields.length" />
                <b-row class="px-4" v-if="driverCustomFields.length">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.customFieldsHeading') }}</h3>
                    <b-col v-for="field in driverCustomFields" :key="field.id" sm="12" class="mt-3">
                        <b-form-group v-if="field.field_type === 'text'" :label="`${field.name}:`"
                            class="text-left mb-0">
                            <b-form-input v-model="customFieldValues[field.id]" type="text"
                                :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })" class="unit"></b-form-input>
                        </b-form-group>
                        <b-form-group v-else-if="field.field_type === 'number'" :label="`${field.name}:`"
                            class="text-left mb-0">
                            <b-form-input v-model="customFieldValues[field.id]" type="number"
                                :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })" class="unit"></b-form-input>
                        </b-form-group>
                        <b-form-group v-else-if="field.field_type === 'date'" :label="`${field.name}:`"
                            class="text-left mb-0">
                            <b-form-input v-model="customFieldValues[field.id]" type="date"
                                :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })" class="unit"></b-form-input>
                        </b-form-group>
                        <div v-else-if="field.field_type === 'select'" class="text-left">
                            <label class="state">{{ field.name }}:</label>
                            <v-select class="f-12" :options="field.options" v-model="customFieldValues[field.id]" />
                        </div>
                        <div v-else-if="field.field_type === 'multi_select'" class="text-left">
                            <label class="state">{{ field.name }}:</label>
                            <v-select class="f-12" :options="field.options" multiple
                                v-model="customFieldValues[field.id]" />
                        </div>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4 sidebar-b-margin">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.assignedEquipmentHeading') }}</h3>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('teamMemberShared.vehicleLabel') }}</label>
                        <v-select class="f-12" :options="vehicleOptions" v-model="newTeamMember.default_vehicle"
                            :reduce="(option) => option.id" @search="searchVehicle" @input="getVehicleData">
                            <template #option="{ label, status }">
                                <div class="d-flex align-items-center">
                                    <span class="equipment-status-indication mr-3"
                                        :class="status === 'Active' ? 'blue-indication' : 'green-indication'"></span>
                                    <span>{{ label }}</span>
                                </div>
                            </template>
                            <span slot="no-options">
                                {{ $t('teamMemberShared.searchUnit') }}
                            </span>
                        </v-select>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3" >
                        <label class="state">{{ $t('teamMemberShared.vehicleTagLabel') }}</label>
                        <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                            v-model="vehicleTags" />
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('teamMemberShared.trailerLabel') }}</label>
                        <v-select class="f-12" :options="trailerOptions" v-model="newTeamMember.default_trailer"
                            :reduce="(option) => option.id" @search="searchTrailer" @input="getTrailerData">
                            <template #option="{ label, status }">
                                <div class="d-flex align-items-center">
                                    <span class="equipment-status-indication mr-3"
                                        :class="status === 'Active' ? 'blue-indication' : 'green-indication'"></span>
                                    <span>{{ label }}</span>
                                </div>
                            </template>
                            <span slot="no-options">
                                {{ $t('teamMemberShared.searchUnit') }}
                            </span>
                        </v-select>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('teamMemberShared.trailerTagLabel') }}</label>
                        <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                            v-model="trailerTags" />
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('teamMemberShared.coDriverLabel') }}</label>
                        <v-select class="f-12" :options="coDrivers" v-model="newTeamMember.co_driver"
                            :reduce="(option) => option.id" @search="searchDriver">
                            <span slot="no-options">
                                {{ $t('teamMemberShared.searchName') }}
                            </span>
                        </v-select>
                    </b-col>
                </b-row>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('teamMemberShared.cancel') }}</b-button>
                    <b-button class="mx-0 h-40px px-2 mr-3 d-none d-sm-block" @click="onAddNewTeamMember(true)"
                        variant="outline-primary">{{ $t('addTeamMember.saveAndOpen') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px" @click="onAddNewTeamMember()" variant="primary">{{ $t('teamMemberShared.save') }}</b-button>
                </div>
            </div>
            <DeleteModal :message="assignedEquipmentMessage" :updateMessage="true" :removeMessage="''"
                v-if="assignedEquipmentMessage" @confirm="verifyEquipmentStatus" />
        </b-sidebar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkEmail, checkPhoneFormat } from '../../services/helper';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    name: "AddTeamMember",
    components: { vSelect, DatePicker, DeleteModal },
    data() {
        return {
            checkEmail,
            checkPhoneFormat,
            errors: {},
            driverTags: [],
            vehicleTags:[],
            trailerTags:[],
            driverCustomFields: [],
            customFieldValues: {},
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            trailerOptions: [],
            vehicleOptions: [],
            showAdditionalSetting: false,
            assignedEquipmentMessage: "",
            assignedExistingTrailer: false,
            assignedExistingVehicle:false,
            coDrivers: [],
            showPassword: false,
            newTeamMember: {
                first_name: "",
                last_name: "",
                role: "Driver",
                email: "",
                username: "",
                phone: "",
                password: "",
                inviteNewMember: false,
                division: null,
                license_number: "",
                license_state: {
                    id: 54,
                    country: 1,
                },
                employee_id: "",
                dob: null,
                default_vehicle: null,
                default_trailer: null,
                co_driver: null,
                activate_date: new Date(),
                inactive_date: null
            },
        }
    },
    props: ['allowAddTeamMember', "states"],
    computed: {
        ...mapGetters([
            "company",
            "userCompany",
            "tags",
            "allEquipments",
            "allDrivers",
            "divisions"
        ]),
        phoneMask() {
            return this.newTeamMember?.phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    methods: {
        ...mapActions([
            "getAllTags",
            "addTeamMember",
            "setNotification",
            "setLoader",
            "getFilteredEquipments",
            "getFilteredDrivers",
            "sendInvite",
            "getCustomFields",
        ]),
        async loadDriverCustomFields() {
            try {
                const list = await this.getCustomFields('driver');
                this.driverCustomFields = (list || [])
                    .filter(f => f.model === 'driver')
                    .slice()
                    .sort((a, b) => (a.order || 0) - (b.order || 0));
                this.initCustomFieldValues();
            } catch (e) {
                console.log(e);
            }
        },
        initCustomFieldValues() {
            const next = {};
            this.driverCustomFields.forEach(f => {
                next[f.id] = f.field_type === 'multi_select' ? [] : null;
            });
            this.customFieldValues = next;
        },
        buildCustomFieldsWrite() {
            return this.driverCustomFields.map(f => {
                let v = this.customFieldValues[f.id];
                if (v === undefined || v === null) {
                    v = f.field_type === 'multi_select' ? [] : null;
                }
                return { id: f.id, value: v };
            });
        },
        verifyEquipmentStatus(status) {
            this.assignedEquipmentMessage = ""
            if (!status) {
                if (this.assignedExistingVehicle) this.newTeamMember.default_vehicle = null
                if(this.assignedExistingTrailer)this.newTeamMember.default_trailer = null
                this.assignedExistingVehicle = false
                this.assignedExistingTrailer = false
            }
        },
        getVehicleData(e) {
            const vehicleData = this.vehicleOptions.find((item) => item.id === e)
            if (vehicleData && vehicleData.status === 'Assigned' && vehicleData.driver_name) {
                this.assignedEquipmentMessage = `<h3 class="f-18 mb-3">${vehicleData.driver_name} is currently using this vehicle.</h3> <p class="text-grey f-14 fw-400 mb-0">Assigning this vehicle, will remove it from the other driver.
                        Are
                        you sure ?</p>`
                this.assignedExistingVehicle = true
            }
        },
        getTrailerData(e) {
            const trailerData = this.trailerOptions.find((item) => item.id === e)
            if (trailerData && trailerData.status === 'Assigned' && trailerData.driver_name) {
                this.assignedEquipmentMessage = `<h3 class="f-18 mb-3">${trailerData.driver_name} is currently using this trailer.</h3> <p class="text-grey f-14 fw-400 mb-0">Assigning this trailer, will remove it from the other driver.
                        Are
                        you sure ?</p>`
                this.assignedExistingTrailer = true
            }
        },
        resetPopup(close = true) {
            this.vehicleOptions = []
            this.trailerOptions = []
            this.coDrivers = []
            this.errors = {}
            this.driverTags = []
            this.vehicleTags =[]
            this.trailerTags =[]
            this.initCustomFieldValues()
            this.showAdditionalSetting = false
            this.newTeamMember = {
                first_name: "",
                last_name: "",
                role: "Driver",
                email: "",
                username: "",
                phone: "",
                password: "",
                inviteNewMember: false,
                co_driver: null,
                division: null,
                license_number: "",
                license_state: {
                    id: 54,
                    country: 1,
                },
                employee_id: "",
                dob: null,
                default_vehicle: null,
                default_trailer: null,
                activate_date: new Date(),
                inactive_date: null
            }
            if (close) this.$emit('close');
        },
        async sendInviteTeamMember(id) {
            try {
                await this.sendInvite({
                    user: id,
                    invite_type: "driver-invite",
                    password: this.newTeamMember.password ? this.newTeamMember.password : null
                });
            } catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                    error = this.$t('addTeamMember.couldNotSendEmail');
                }
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async onAddNewTeamMember(openTeamMember = false) {
            const user = {
                first_name: this.newTeamMember.first_name,
                last_name: this.newTeamMember.last_name,
                username:
                    this.newTeamMember.username + "." + this.company[0].company_ID,
            };
            if (this.newTeamMember.password)
                user["password"] = this.newTeamMember.password;
            if (this.newTeamMember.email) {
                user["email"] = this.newTeamMember.email;
            }
            let postData = {
                user,
                role: this.newTeamMember.role,
                phone: this.newTeamMember.phone,
            };
            if (this.newTeamMember.role === "Driver") {
                postData = {
                    ...postData,
                    ...this.newTeamMember,
                    tags: this.driverTags,
                    vehicle_assignment_tags: this.vehicleTags,
                    trailer_assignment_tags: this.trailerTags,
                    dob: this.newTeamMember.dob ? moment(this.newTeamMember.dob).format("YYYY-MM-DD") : null,
                    activate_date: moment(this.newTeamMember.activate_date).format('YYYY-MM-DD'),
                    inactive_date: this.newTeamMember.inactive_date ? moment(this.newTeamMember.inactive_date).format("YYYY-MM-DD") : null,
                    license_number: this.newTeamMember.license_number,
                    license_state: this.newTeamMember.license_state.id
                        ? this.newTeamMember.license_state.id
                        : 54,
                    lock_trailer: this.company[0].lock_trailer,
                    lock_vehicle: this.company[0].lock_vehicle,
                    phone: this.newTeamMember.phone ? !this.newTeamMember.phone.includes("+1") ? "+1 " + this.newTeamMember.phone : this.newTeamMember.phone : '',
                    ...this.newTeamMember.default_trailer && { assigned_trailers: [this.newTeamMember.default_trailer] },
                    custom_fields_write: this.buildCustomFieldsWrite(),
                };
                delete this.newTeamMember.default_trailer
            }
            try {
                if (this.newTeamMember.phone) {
                    if (!this.checkPhoneFormat(this.newTeamMember.phone)) {
                        throw {
                            phone: [this.$t('teamMemberShared.wrongFormat')],
                        };
                    }
                }
                if (this.newTeamMember.email) {
                    if (!this.checkEmail(this.newTeamMember.email)) {
                        throw {
                            email: [this.$t('teamMemberShared.wrongFormat')],
                        };
                    }
                }
                if (this.newTeamMember.username) {
                    if (this.newTeamMember.username.includes("@") || this.newTeamMember.username.includes(" ")) {
                        throw {
                            username: [this.$t('teamMemberShared.usernameNoSpecialChars')],
                        };
                    }
                }
                if (this.newTeamMember.username && this.newTeamMember.username.includes(`.${this.company[0].company_ID}`)) {
                    await this.setNotification({
                        msg: this.$t('teamMemberShared.usernameNoCompId'),
                        type: "error",
                        color: "red",
                    });
                    return;
                }
                const nullKeys = this.checkNullValues({
                    first_name: this.newTeamMember.first_name,
                    last_name: this.newTeamMember.last_name,
                    role: this.newTeamMember.role,
                    username: this.newTeamMember.username,
                    password: this.newTeamMember.password,
                    ...this.company[0].is_division_required ? { division: this.newTeamMember.division } : {}
                });

                if (nullKeys.length === 0) {
                    try {
                        this.setLoader(true);
                        const newMember = await this.addTeamMember(postData);
                        if (newMember) {
                            if (
                                this.newTeamMember.inviteNewMember &&
                                this.newTeamMember.email
                            ) {
                                if (this.newTeamMember.email) {
                                    await this.sendInviteTeamMember(newMember.id);
                                    await this.setNotification({
                                        msg: this.$t('addTeamMember.addedAndInvited', { name: `${newMember.user.first_name} ${newMember.user.last_name}` }),
                                        type: "success",
                                        color: "green",
                                    });
                                } else
                                    await this.setNotification({
                                        msg: this.$t('addTeamMember.addedNoEmail', { name: `${newMember.user.first_name} ${newMember.user.last_name}` }),
                                        type: "success",
                                        color: "green",
                                    });
                            } else {
                                await this.setNotification({
                                    msg: this.$t('addTeamMember.added', { name: `${newMember.user.first_name} ${newMember.user.last_name}` }),
                                    type: "success",
                                    color: "green",
                                });
                            }
                            this.resetPopup(false)
                            if (openTeamMember) this.$emit("getNewData", newMember.id)
                            else this.$emit("getNewData", null)
                        }
                        this.showPassword = false
                        this.setLoader(false);
                    } catch (e) {
                        console.log(e)
                        this.setLoader(false);
                        if (Array.isArray(e)) {
                            await this.setNotification({
                                msg: e[0],
                                type: "error",
                                color: "red",
                            });
                        }
                        else if (typeof e === "object") {
                            console.log(e)
                            await this.setNotification({
                                msg: e['error'][0],
                                type: "error",
                                color: "red",
                            });
                        }
                        else {
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                        }

                    }
                } else {
                    this.setLoader(false);
                    let error = {};
                    nullKeys.forEach((x) => {
                        if (x === 'password' && this.newTeamMember.password && this.newTeamMember.password.length < 4) error['password'] = [this.$t('teamMemberShared.passwordMinLength')]
                        else error[x] = [this.$t('teamMemberShared.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },

        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (key === "password" && value.length < 4 || !value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async searchVehicle(searchText) {
            if (searchText) {
                const records = await this.getFilteredEquipments({ unit_no: searchText, type: 'Vehicle', status:'Active,Assigned' });
                this.typeOptions(records)
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                const records = await this.getFilteredEquipments({ unit_no: searchText, type: 'Trailer', status:'Active,Assigned' });
                this.subTypeOptions(records)
            }
        },
        typeOptions(records) {
            let options = [];
            records.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                    status: x.status,
                    driver_id: x.driver_id,
                    driver_name: x.driver_name
                });
            });
            this.vehicleOptions = this.vehicleOptions.concat(options)
            this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
        },
        subTypeOptions(records) {
            let options = [];
            records.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                    status: x.status,
                    driver_id: x.driver_id,
                    driver_name: x.driver_name
                });
            });
            this.trailerOptions = this.trailerOptions.concat(options)
            this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
        },
        async searchDriver(searchText) {
            if (searchText) {
                const driverRecords = await this.getFilteredDrivers(searchText);
                this.coDrivers = []
                driverRecords
                    .filter(
                        (driver) =>
                            !driver.co_driver
                    )
                    .map((item) => {
                        this.coDrivers.push({
                            id: item.id,
                            label: item.name,
                        });
                    });
            }
        },
    },
    async mounted() {
        await this.getAllTags(this.userCompany);
        await this.loadDriverCustomFields();
    }
}
</script>
<style>
.equipment-status-indication {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.blue-indication {
    background-color: rgb(45, 105, 246);
}

.green-indication {
    background-color: rgb(44, 206, 137);
}
</style>
